import {
    faArrowAltCircleLeft,
    faArrowAltCircleRight,
    faArrowsLeftRight,
    faAsterisk,
    faCheck,
    faFileContract,
    faLink,
    faLinkSlash,
    faRotate,
} from "@fortawesome/free-solid-svg-icons";

//const projectManagementSystemsKeys = Object.keys(projectManagementSystems);
//const erp_keys = Object.keys(accountingSystems);

const colors = {
    blue: "var(--bs-info)",
    orange: "var(--bs-warning)",
    default: "var(--dimensionDarkGray)",
    green: "var(--bs-success)",
    red: "var(--bs-danger)",
};

const directions = {
    get: {
        color: colors.orange,
        icon: faArrowAltCircleRight,
        title: "Get data",
    },
    send: {
        color: colors.blue,
        icon: faArrowAltCircleLeft,
        title: "Send data",
    },
    link: {
        color: colors.green,
        icon: faLink,
        title: "Link data",
    },
    unlink: {
        color: colors.red,
        icon: faLinkSlash,
        title: "Unlink data",
    },
    within: {
        color: colors.default,
        icon: faRotate,
        title: "Process data within a system",
    },
    compare: {
        color: colors.default,
        icon: faCheck,
        title: "Compare data",
    },
    report: {
        color: colors.default,
        icon: faFileContract,
        title: "Report data",
    },
    to_both: {
        color: colors.default,
        icon: faArrowsLeftRight,
        title: "Both send and get data",
    },
    to_neither: {
        color: colors.default,
        icon: faAsterisk,
        title: "Neither send nor get data",
    },
};

export const direction = {
    /** Parses integration table record's direction column and returns direction, color, title, icon.
     * Used in integration home page and run details page.
     */
    getDirectionInfo: function (directionIn) {
        if (directionIn === undefined || directionIn === null) directionIn = "";

        directionIn = makeSnakeCaseLowerCase(directionIn);

        let directionInfo = directions[directionIn];
        if (directionInfo) {
            return directionInfo;
        }

        directionInfo = {
            direction: directionIn,
            color: colors.default,
            icon: faAsterisk,
            title: "Run Integration",
        };

        return directionInfo;
    },

    /** Parses a company table's systems column and returns every possible list of directions.
     * Used to generate select options dropdown menu in the edit integrations page.
     */
    getDirectionsForSystems: function () {
        const directionsList = Object.keys(directions);

        return directionsList;
    },
};

function makeSnakeCaseLowerCase(direction_in) {
    direction_in = direction_in.replace(/([A-Z])/g, function ($1) {
        return "_" + $1.toLowerCase();
    });
    if (direction_in.startsWith("_")) {
        direction_in = direction_in.substring(1);
    }

    return direction_in;
}
